import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UnopenedAccessRequestsCountSubscriptionVariables = Types.Exact<{
  scope: Types.NotificationGroupScopeInput;
}>;


export type UnopenedAccessRequestsCountSubscription = { __typename?: 'Subscription', notificationGroup?: { __typename?: 'NotificationGroupUnopenedCountUpdatePayload', timestamp: string, notificationGroups: { __typename?: 'NotificationGroupConnection', totalCount: number, nodes: Array<{ __typename?: 'NotificationGroupAccessRequestApproved' } | { __typename?: 'NotificationGroupAccessRequestDenied' } | { __typename?: 'NotificationGroupAccessRequestSubmitted', id: string } | { __typename?: 'NotificationGroupAssetAssignedToYou' } | { __typename?: 'NotificationGroupAssetStatusChanged' } | { __typename?: 'NotificationGroupCommentCreated' } | { __typename?: 'NotificationGroupCommentCreatedShareAccess' } | { __typename?: 'NotificationGroupFileUploaded' } | { __typename?: 'NotificationGroupReplyCreated' } | { __typename?: 'NotificationGroupReplyCreatedShareAccess' } | { __typename?: 'NotificationGroupRequesterAccessRequestApproved' } | { __typename?: 'NotificationGroupRequesterAccessRequestDenied' } | { __typename?: 'NotificationGroupTranscriptCompletedSelf' } | { __typename?: 'NotificationGroupTransferBatchCompleted' } | { __typename?: 'NotificationGroupTransferBatchCompletedSelf' } | { __typename?: 'NotificationGroupUserMentioned' } | { __typename?: 'NotificationGroupUserMentionedShareAccess' }> } } | null };


export const UnopenedAccessRequestsCount = /*#__PURE__*/ gql`
    subscription UnopenedAccessRequestsCount($scope: NotificationGroupScopeInput!) {
  notificationGroup(scope: $scope) {
    ... on NotificationGroupUnopenedCountUpdatePayload {
      timestamp
      notificationGroups {
        nodes {
          ... on NotificationGroupAccessRequestSubmitted {
            id
          }
        }
        totalCount
      }
    }
  }
}
    ` as unknown as DocumentNode<UnopenedAccessRequestsCountSubscription, UnopenedAccessRequestsCountSubscriptionVariables>;

          

          export const useUnopenedAccessRequestsCountSubscription = (options?:SubscriptionHookOptions<UnopenedAccessRequestsCountSubscription, UnopenedAccessRequestsCountSubscriptionVariables>) => useSubscription(UnopenedAccessRequestsCount, options);

          

          export type UnopenedAccessRequestsCountSubscriptionOptions = SubscriptionHookOptions<UnopenedAccessRequestsCountSubscription, UnopenedAccessRequestsCountSubscriptionVariables>;

          

          export type UnopenedAccessRequestsCountSubscriptionResult = ReturnType<typeof useUnopenedAccessRequestsCountSubscription>;

          
